<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label for="form-pass-region" class="control-label">{{ inputLabel }}</label>
    <treeselect
      :options="items"
      :multiple="true"
      :disabled="disabled"
      :clearable="false"
      :max-height="200"
      :value="inputValue"
      placeholder=""
      @select="checkSector($event)"
      @deselect="uncheckSector($event)"
      @close="defineRegion()"
    >
      <div slot="value-label" slot-scope="{ node }">{{ node.raw.customLabel }}</div>
    </treeselect>
    <div v-if="showError || hasInputErrors" class="help-block error-text">
      Выберите территорию
    </div>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'
import passInputMixin from '../../../../mixins/application-form/passInputMixin'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { cloneObject } from '@/common/helpers'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'TerminalSectorInput',

  data () {
    return {
      inputValue: [],
      checkedList: [],
      isValidSectorSet: true
    }
  },

  components: {
    Hint,
    Treeselect
  },

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin,
    passInputMixin
  ],

  props: {
    inputLabel: {
      default: 'Территории посещения'
    },

    inputName: {
      default: 'terminal_sector_id'
    },

    inputHint: {
      default: undefined
    },

    items: {
      type: [Array, Object],
      default: () => []
    },

    rawSectorList: {
      type: [Array, Object],
      default: () => []
    },

    terminalRegionSectors: {
      type: [Array, Object],
      default: () => []
    }
  },

  watch: {
    items() {
      this.inputValue = [];
      this.checkedList = [];
      if ((this.isDuplicate || this.isDraft || this.isView) && this.form.application.terminal_sectors.length > 0) {
        let sectorsSet = this.form.application.terminal_sectors
        sectorsSet.forEach((item) => {
          let currentSector = this.findSectorInRawList(item)
          let sectorChildren = this.getChildSectors(item)
          if (sectorChildren.length === 0) {
            this.checkSector(currentSector)
          }
        })
      }
      if (this.isView) {
        this.rawSectorList.forEach((item) => {
          let sectorInTree = this.findSectorInTree(item)
          sectorInTree.isDisabled = true
        })
      }

      if (this.rawSectorList.length === 1) {
        let sectorInTree = this.findSectorInTree(this.rawSectorList[0])
        sectorInTree.isDisabled = true

        if (!this.isSectorInCheckedList(sectorInTree.id)) {
          this.checkedList.push(sectorInTree.id)
        }
        if (!this.isSectorInInputValue(sectorInTree.id)) {
          this.inputValue.push(sectorInTree.id)
        }
      }
      if (this.isDuplicate || this.isDraft) {
        this.defineRegion()
      }
    },
    checkedList() {
      this.defineRegion()
    }
  },

  computed: {
    showError() {
      return !this.isValidSectorSet && this.checkedList.length > 0 && !this.isView
    }
  },

  methods: {
    checkSector(sector) {
      this.doParentsCheck(sector)
      let childSectors = this.getChildSectors(sector.id)

      if (childSectors.length > 0) {

        childSectors.forEach((item) => {
          let childInTree = this.findSectorInTree(item)
          if (!childInTree.isDisabled) {
            this.checkSector(item)
          }
        })
      }

      if (childSectors.length === 0) {
        if (!this.isSectorInCheckedList(sector.id)) {
          this.inputValue.push(Number(sector.id))
        }
      }
      if (!this.isSectorInCheckedList(sector.id)) {
        this.checkedList.push(Number(sector.id))

        this.doSectorsToCheck(sector)
        this.doSectorsToDisable(sector)
      }
    },

    doParentsCheck(sector) {
      let wayToSector = (cloneObject(sector.wayToSector)).reverse()
      wayToSector.forEach((item) => {
        if (!this.isSectorInCheckedList(item)) {
          this.checkedList.push(Number(item))

          let sectorInRawList = this.findSectorInRawList(item)
          this.doSectorsToCheck(sectorInRawList)
          this.doSectorsToDisable(sectorInRawList)
        }
      })
    },

    uncheckSector(sector) {
      this.doParentsUncheck(sector)
      let childSectors = this.getChildSectors(sector.id)

      if (childSectors.length > 0) {

        childSectors.forEach((item) => {
          this.uncheckSector(item)
        })
      }

      if (childSectors.length === 0 && this.isSectorInInputValue(sector.id)) {
        let sectorIndex = this.inputValue.indexOf(sector.id)
        this.inputValue.splice(sectorIndex, 1)
      }

      if (this.isSectorInCheckedList(sector.id)) {
        let sectorIndex = this.checkedList.findIndex((element) => element === sector.id)
        this.checkedList.splice(sectorIndex, 1)

        this.cancelSectorsToCheck(sector)
        this.cancelSectorsToDisable(sector)
      }
    },

    doParentsUncheck(sector) {
      let wayToSector = (cloneObject(sector.wayToSector)).reverse()
      wayToSector.forEach((item) => {

        let sectorInRawList = this.findSectorInRawList(item)
        let parentHaveOtherCheckedChildren = false;
        sectorInRawList.children.forEach((child) => {
          if (child.id !== sector.id && this.isSectorInCheckedList(child.id)) {
            parentHaveOtherCheckedChildren = true
          }
        })

        if (!parentHaveOtherCheckedChildren && this.isSectorInCheckedList(item)) {
          let sectorIndex = this.checkedList.findIndex((element) => element === item)
          this.checkedList.splice(sectorIndex, 1)

          this.cancelSectorsToCheck(sectorInRawList)
          this.cancelSectorsToDisable(sectorInRawList)
        }
      })
    },

    doSectorsToCheck(sector) {
      sector.sectorsToCheck.forEach((item) => {
        let sectorInRawList = this.findSectorInRawList(item)
        this.checkSector(sectorInRawList)
        let sectorInTree = this.findSectorInTree(sectorInRawList)
        sectorInTree.isDisabled = true
      })
    },

    doSectorsToDisable(sector) {
      sector.sectorsToDisable.forEach((item) => {
        let sectorInRawList = this.findSectorInRawList(item)
        if (sectorInRawList) {
          let sectorInTree = this.findSectorInTree(sectorInRawList)
          if (this.isSectorInCheckedList(item)) {
            this.uncheckSector(sectorInRawList)
          }
          sectorInTree.isDisabled = true
        }
      })
    },

    cancelSectorsToCheck(sector) {
      sector.sectorsToCheck.forEach((item) => {
        let usedInAnotherToCheck = this.usedInAnotherCheckedSectorsToCheck(sector, item)
        let usedInAnotherToDisable = this.usedInAnotherCheckedSectorsToDisable(sector, item)
        if (!usedInAnotherToCheck) {
          let sectorInRawList = this.findSectorInRawList(item)
          this.uncheckSector(sectorInRawList)
        }

        if (!usedInAnotherToCheck && !usedInAnotherToDisable) {
          let sectorInRawList = this.findSectorInRawList(item)
          let sectorInTree = this.findSectorInTree(sectorInRawList)
          sectorInTree.isDisabled = false
        }
      })
    },

    cancelSectorsToDisable(sector) {
      sector.sectorsToDisable.forEach((item) => {
        let usedInAnotherToCheck = this.usedInAnotherCheckedSectorsToCheck(sector, item)
        let usedInAnotherToDisable = this.usedInAnotherCheckedSectorsToDisable(sector, item)
        let sectorInRawList = this.findSectorInRawList(item)

        if (!usedInAnotherToCheck && !usedInAnotherToDisable) {
          let sectorInTree = this.findSectorInTree(sectorInRawList)
          sectorInTree.isDisabled = false
        }

        if (usedInAnotherToCheck && !usedInAnotherToDisable) {
          this.checkSector(sectorInRawList)
        }
      })
    },

    usedInAnotherCheckedSectorsToCheck(sectorOwner, sectorId) {
      let anotherSectorOwners = this.rawSectorList.filter((item) => {
        return Number(item.sectorsToCheck.indexOf(sectorId)) !== -1 &&
          this.checkedList &&
          this.isSectorInCheckedList(item.id)
      })

      return anotherSectorOwners.length > 0
    },

    usedInAnotherCheckedSectorsToDisable(sectorOwner, sectorId) {
      let anotherSectorOwners = this.rawSectorList.filter((item) => {
        return Number(item.sectorsToDisable.indexOf(sectorId)) !== -1 &&
          this.checkedList &&
          this.isSectorInCheckedList(item.id)
      })

      return anotherSectorOwners.length > 0
    },

    findSectorInTree(sector) {
      let wayToSector = (cloneObject(sector.wayToSector)).reverse()
      let currentSector = wayToSector.length > 0 ? this.items.find((item) => item.id === wayToSector[0]) : this.items.find((item) => item.id === sector.id)
      wayToSector.shift()

      while (currentSector.id !== sector.id) {
        let nextSector = currentSector.children.find((item) => item.id === sector.id)

        if (!nextSector) {
          nextSector = currentSector.children.find((item) => item.id === wayToSector[0])
          wayToSector.shift()
        }
        currentSector = nextSector
      }

      return currentSector
    },

    findSectorInRawList(sectorId) {
      return this.rawSectorList.find((element) => Number(element.id) === Number(sectorId))
    },

    isSectorInCheckedList(sectorId) {
      return this.checkedList.findIndex((element) => element === (Number(sectorId))) !== -1
    },

    isSectorInInputValue(sectorId) {
      return this.inputValue.findIndex((element) => element === (Number(sectorId))) !== -1
    },

    getChildSectors(sectorId) {
      return this.rawSectorList.filter((item) => Number(item.parent_id) === Number(sectorId))
    },

    defineRegion() {
      let result = false
      if (this.checkedList.length > 0) {
        this.terminalRegionSectors.forEach((item) => {
          if (result === false && this.compareSectorSets(item.sectors_set)) {
            this.form.application.terminal_region_id = item.terminal_region_id
            this.$emit('change', this.form.application.terminal_region_id)
            this.isValidSectorSet = true
            result = true
          }
        })
      }
      if (!result) {
        this.form.application.terminal_region_id = null
        this.$emit('change', this.form.application.terminal_region_id)
        this.isValidSectorSet = false
      }
      this.form.application.terminal_sectors = this.checkedList
    },

    compareSectorSets(inputSectorSet) {
      if (this.checkedList.length !== inputSectorSet.length) {
        return false
      }

      const hasNotChecked = inputSectorSet.some((item) => !this.isSectorInCheckedList(item));

      return !hasNotChecked;
    }
  }
}
</script>
